import { useLocation, useNavigate } from "react-router-dom";
import { AppRoute } from "../../interfaces/app-routes";
import MaterialIcon, {
  MtIcon,
} from "../../ui-elements/material-icon/material-icon";
import styles from "./bottom-nav-bar.module.scss";

interface INavItem {
  name: string;
  path: string;
  icon: MtIcon;
}

const navItems: INavItem[] = [
  {
    name: "Home",
    path: AppRoute.HOME,
    icon: "home",
  },
  {
    name: "Devices",
    path: AppRoute.DEVICES,
    icon: "ev_station",
  },
  {
    name: "History",
    path: AppRoute.HISTORY,
    icon: "pie_chart",
  },
  {
    name: "DLB",
    path: AppRoute.DLB,
    icon: "display_settings",
  },
  {
    name: "Users",
    path: AppRoute.USERS,
    icon: "person",
  },
];

const BottomNavBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isItemActive = (itemPath: string) => {
    if (itemPath === AppRoute.HOME) {
      return (
        pathname === AppRoute.HOME ||
        pathname === AppRoute.DASHBOARD ||
        pathname === "/dashboard"
      );
    }
    return pathname === itemPath || pathname.startsWith(itemPath + "/");
  };

  return (
    <nav
      className={`${styles.bottomNavContainer} d-flex d-md-none`}
      aria-label="Mobile bottom navigation"
    >
      {navItems.map((item) => {
        const active = isItemActive(item.path);
        return (
          <button
            type="button"
            key={item.name}
            className={`${styles.navItem} ${active ? styles.active : ""}`}
            onClick={() => navigate(item.path)}
            aria-label={item.name}
          >
            <MaterialIcon
              icon={item.icon}
              size={24}
              color={active ? "var(--primary)" : "var(--light)"}
            />
            <span className={styles.navLabel}>{item.name}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNavBar;
